import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  BaseCssProperties,
  ProviderClass,
  baseCssConfigStyle,
  buttonNestedWidgetConfigStyles,
} from '@finxone-platform/shared/sys-config-types';

import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { mapFormToFormWithDestinationIdentifier } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/beneficiary-zone/submit-edit-beneficiary-request.utils';
import {
  buildHandleBarModel,
  filterIfHandlebarNotRendered,
} from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { IconCacheService } from '@finxone-platform/shared/services';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';
import { BaseComponent } from '../../../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-edit-beneficiary-international-beneficiary-credentials-widget',
  templateUrl: './edit-beneficiary-international-beneficiary-credentials-widget.component.html',
})
export class EditBeneficiaryInternationalBeneficiaryCredentialsWidgetComponent
  extends BaseComponent
  implements OnInit
{
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();

  public addressRequired: string;
  public recipientName: string;
  public beneficiaryType: string;
  public continueButtonContent = 'Continue';
  public previousButtonContent: string;
  public nextButtonContent: string;
  public previousButtonStyle: baseCssConfigStyle = {};
  public nextButtonStyle: baseCssConfigStyle = {};

  public isSubmitTypeAsynchronous = true;
  public firstName: string;
  public lastName: string;
  public buttonGlobalStyles = {
    continueButton: {
      globalStylingClass: '',
      isAllowedGlobalStyling: false,
    },
    previousButton: {
      globalStylingClass: '',
      isAllowedGlobalStyling: false,
    },
    nextButton: {
      globalStylingClass: '',
      isAllowedGlobalStyling: false,
    },
  };

  constructor(
    public dataIn: ProviderClass<any>,
    private configService: ConfigService,
    private store: Store,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
    private accountService: AccountService,
  ) {
    super();
    this.recipientName = 'name';
    this.firstName = 'firstName';
    this.lastName = 'lastName';
  }
  ngOnInit(): void {
    this.beneficiaryType = this.dataIn.attri.widgetProperties['beneficiaryType'];

    if (this.dataIn.widgetConfig?.nestedWidgets?.['previousButton']) {
      this.getButtonContent('previousButton', 'Previous', 'previousButtonContent');
      this.previousButtonStyle = this.configService.getSpecificBaseCssStyle(
        this.getNestedWidgetConfig(this.dataIn, 'previousButton'),
        buttonNestedWidgetConfigStyles,
      );
    } else {
      this.previousButtonStyle = {};
    }

    if (this.dataIn.widgetConfig?.nestedWidgets?.['nextButton']) {
      this.getButtonContent('nextButton', 'Next', 'nextButtonContent');
      this.nextButtonStyle = this.configService.getSpecificBaseCssStyle(
        this.getNestedWidgetConfig(this.dataIn, 'nextButton'),
        buttonNestedWidgetConfigStyles,
      );
    } else {
      this.nextButtonStyle = {};
    }

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.dataIn.attri, [
      BaseCssProperties.PADDING,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.MARGIN,
      BaseCssProperties.BORDER,
      BaseCssProperties.BOX_SHADOW,
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXT_FONT_STYLE,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXTALIGN,
    ]);
    this.getGlobalStyling();
  }

  private getButtonContent(buttonKey: string, defaultText: string, buttonContentKey: string): void {
    const buttonText =
      this.dataIn.widgetConfig?.nestedWidgets?.[buttonKey]?.widgetProperties?.textContent ?? defaultText;
    const template = Handlebars.compile(buttonText);
    buildHandleBarModel(
      this.store,
      buttonText,
      this.countriesCurrenciesService,
      this.iconCacheService,
      this.accountService,
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        (this as any)[buttonContentKey] = filterIfHandlebarNotRendered(template(model));
      });
  }

  private getGlobalStyling() {
    if (
      this.dataIn.widgetConfig.nestedWidgets?.['previousButton'].widgetProperties?.['globalStylingClass'] &&
      this.dataIn.widgetConfig.nestedWidgets?.['previousButton'].widgetProperties?.['globalStyling']
    ) {
      this.buttonGlobalStyles.previousButton.globalStylingClass =
        this.dataIn.widgetConfig.nestedWidgets?.['previousButton'].widgetProperties?.['globalStylingClass'] ??
        '';
      this.buttonGlobalStyles.previousButton.isAllowedGlobalStyling =
        this.dataIn.widgetConfig.nestedWidgets?.['previousButton'].widgetProperties?.['globalStyling'] ??
        false;
    }

    if (
      this.dataIn.widgetConfig.nestedWidgets?.['nextButton'].widgetProperties?.['globalStylingClass'] &&
      this.dataIn.widgetConfig.nestedWidgets?.['nextButton'].widgetProperties?.['globalStyling']
    ) {
      this.buttonGlobalStyles.nextButton.globalStylingClass =
        this.dataIn.widgetConfig.nestedWidgets?.['nextButton'].widgetProperties?.['globalStylingClass'] ?? '';
      this.buttonGlobalStyles.nextButton.isAllowedGlobalStyling =
        this.dataIn.widgetConfig.nestedWidgets?.['nextButton'].widgetProperties?.['globalStyling'] ?? false;
    }
  }

  get widgetProperties() {
    return this.dataIn.attri.widgetProperties;
  }

  public updateFormActionStateOnChange(event: any) {
    this.store.dispatch(
      new UpdateFormDataActionWithId(
        mapFormToFormWithDestinationIdentifier(event),
        FormActionTypeEnum.INTL_BENEFICIARY_ADD,
      ),
    );
  }
}
